<template>
  <div>
    <div v-if="file" class="card-file-upload">
      <div class="card-file-upload-text">
        <span>{{ fileName }}</span>
        <p>Archivo cargado</p>
      </div>
      <button>
        <img
          class=""
          :src="require('@/assets/images/icons/delete-bin-2-line.svg')"
          @click.prevent="removeFile"
        />
      </button>
    </div>
    <div v-else>
      <a
        class="download-template"
        :href="`${host}/v2/health-tracker/ges-user-template`"
        target="_blank"
        >
          <img src="@/assets/images/icons/download-cloud.svg" alt="">
          <span>Descarga la plantilla para subir archivo de empleados</span>
        </a
      >
      <form
        id="file-upload-form"
        class="uploader"
        @dragover.prevent
        @drop="handleDrop"
      >
        <input
          id="employee"
          type="file"
          @change="filesSelected"
          accept=".xlsx"
        />
        <label for="employee" id="file-drag" class="pointer upload-employee">
          <div>
            <img src="@/assets/images/icons/upload-cloud-2-line.svg" />
          </div>
          <p v-if="fileName === ''">
            Sube aquí el archivo de empleados para carga masiva.
          </p>
          <p v-else>{{ fileName }}</p>
          <button id="employee-btn" @click.prevent="openFileExplorer">
            Cargar archivo
          </button>
        </label>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      fileName: "",
      file: null,
      host: process.env.VUE_APP_URL_API,
    };
  },
  methods: {
    filesSelected(event) {
      event.preventDefault();
      const me = this;
      const file = document.querySelector("#employee");
      me.file = file.files[0];
      me.fileName = file.files[0].name;
      me.validateFile();
    },
    handleDrop(event) {
      const me = this;
      event.preventDefault();
      me.file = event.dataTransfer.files[0];
      me.fileName = me.file.name;
      me.validateFile();
    },
    openFileExplorer() {
      document.querySelector("#employee").click();
    },
    validateFile() {
      const me = this;
      if (
        me.file.type !==
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      ) {
        me.fileName = "";
        me.file = null;
        this.$bvToast.toast("El archivo debe ser .xlsx", {
          title: "Error al subir el archivo",
          autoHideDelay: 3000,
          appendToast: true,
          variant: "danger",
          solid: true,
        });
        return false;
      }
      me.$emit("uploadFile", me.file);
    },
    removeFile() {
      const me = this;
      me.fileName = "";
      me.file = null;
      me.$emit("uploadFile", me.file);
    },
  },
};
</script>

<style lang="scss">
.upload-employee {
  display: flex !important;
  justify-content: space-between !important;
  gap: 10px !important;
  align-items: center !important;
  padding: 8px !important;
  border-radius: 8px;
  position: relative;
  z-index: 999;
  margin-bottom: 25px !important;
}
.upload-employee p {
  font-size: 12px !important;
  margin-bottom: 0 !important;
  text-align: left !important;
  color: #263238 !important;
}
.upload-employee img {
  width: 32px !important;
  height: 32px !important;
}
.upload-employee button {
  display: flex;
  align-items: center;
  background-color: #5d5fef;
  height: 32px;
  border-radius: 4px;
  font-size: 16px;
  border: none;
  color: white;
  padding: 6px 0px;
  width: 230px;
  justify-content: center;
}
.card-file-upload {
  display: flex;
  justify-content: space-between;
  height: 60px;
  padding: 12px 8px 12px 8px;
  border-radius: 4px;
  border: 1px solid #eceff1;
  background-color: white;
  margin-bottom: 25px;
}
.card-file-upload .card-file-upload-text {
  display: flex;
  flex-direction: column;
  justify-content: start;
  font-size: 12px;
  color: #263238;
}
.card-file-upload .card-file-upload-text p {
  font-size: 12px;
  color: #1719dacf;
}
.card-file-upload button {
  border: none;
  background-color: transparent;
  padding: 0;
}
.download-template {
  display: flex;
  width: 100%;
  font-size: 14px;
  color: #1719dacf;
  text-decoration: underline;
  cursor: pointer;
  margin-bottom: 10px;
}

.download-template img {
  margin-right: 5px;
}
</style>
